<script>
  import {Doughnut, mixins} from 'vue-chartjs'
  import datalabels from 'chartjs-plugin-datalabels'
  import _ from 'lodash'

  export default ({
    extends: Doughnut,
    mixins: [mixins.reactiveProp],
    name: 'DoughnutChart',
    props: ['chartData'],
    data () {
      return {
        options: {
          responsive: true,
          plugins: datalabels
        }
      }
    },
    mounted () {
      this.renderChart(this.chartData, {
        responsive: true,
        legend: false,
        plugins: {
          datalabels: {
            formatter (value, context) {
              let total = 0
              _.forEach(context.dataset.data, count => {
                total += count
              })
              let percent = parseInt((Math.round((value / total) * 100) / 100) * 100)
              return isNaN(percent) ? 0 + '%' : percent + '%'
            }
          }
        }
      })
    }
  })
</script>


// WEBPACK FOOTER //
// src/components/widgets/charts/DoughnutChart.vue